import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ErrorHandlingService } from "src/app/features/ada-access/shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../secure-blockchain-api-endpoints";
import { FabricChaincode } from "@aptsi-types";

@Injectable({
    providedIn: 'root'
})
export class SmartContractViewService {

    private baseUrl = environment.apiUrl;

    constructor(
        private http: HttpClient,
        private errorHandlingService: ErrorHandlingService
    ) { }

    // ---------------- GET CONTRACTS ----------------
    getContracts(organizationId: string | null): Observable<FabricChaincode[]> {
        return this.http.post<any>(
            `${this.baseUrl}${API_ENDPOINTS.VIEW.READ}`, { organizationId }
        ).pipe(
            map(res => {
                const key = Object.keys(res)[0];
                return (res[key] ?? []) as FabricChaincode[];
            }),
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }

    // ---------------- SEARCH ----------------
    searchContracts(
        currentPage: number,
        searchText: string,
        category: string,
        organizationId: string | null
    ): Observable<FabricChaincode[]> {
        return this.http.post<any>(
            `${this.baseUrl}${API_ENDPOINTS.OPERATION.SEARCH}`,
            { currentPage, searchText, category, organizationId }
        ).pipe(
            map(res => (res.chaincodes || res) as FabricChaincode[]),
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }

    // ---------------- GET KEYS ----------------
    getKeys(channel: string, chaincode: string): Observable<any[]> {
        return this.http.post<any>(
            `${this.baseUrl}${API_ENDPOINTS.VIEW.KEYS}`,
            { channel, chaincode }
        ).pipe(
            map(res => res.data || []),
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }

    // ---------------- GET HISTORY ----------------
    getHistory(
        channel: string,
        chaincode: string,
        key: string
    ): Observable<any[]> {
        return this.http.post<any>(
            `${this.baseUrl}${API_ENDPOINTS.VIEW.HISTORY}`,
            { channel, chaincode, key }
        ).pipe(
            map(res => res.data || []),
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }
}